/**
 * Constantes de Usuários da Plataforma.
 * Os cargos são importados da página de Permissões (fonte única de verdade).
 */
import { ROLE_LABELS as PERMISSION_ROLE_LABELS } from "../../Permissions/constants";

// Gera as opções de cargo dinamicamente dos cargos da matriz de permissões
export const ROLE_OPTIONS = Object.entries(PERMISSION_ROLE_LABELS).map(([key, label]) => ({
    value: key,
    label,
}));

export const ROLE_LABELS = PERMISSION_ROLE_LABELS;

export const USER_DEFAULTS = {
    fullName: "",
    email: "",
    platformRole: "suporte",
    position: "",
    phone: "",
    photoUrl: "",
    password: "",
    status: "active",
    zipCode: "",
    street: "",
    number: "",
    neighborhood: "",
    city: "",
    state: "",
    complement: "",
};
